import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-adminstration',
  templateUrl: './adminstration.component.html',
  styleUrls: ['./adminstration.component.scss'],
})

export class AdminstrationComponent implements OnInit {
  constructor() { }

  ngOnInit(): void {
  }

}
  
